import type { IconProps } from './types/types';

const SpinnerIcon = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      width="92"
      height="92"
      viewBox="0 0 92 92"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.4652 17.7431C9.9242 28.9269 6.39202 50.5916 17.5758 66.1326C28.7596 81.6735 50.4244 85.2057 65.9653 74.0219C78.6207 64.9147 83.3212 48.8461 78.5741 34.7953C77.6019 31.9175 79.1466 28.7964 82.0244 27.8242C84.9021 26.8519 88.0232 28.3967 88.9954 31.2744C95.2452 49.7731 89.0769 70.9423 72.3905 82.9503C51.9185 97.6827 23.3798 93.0298 8.6474 72.5578C-6.08494 52.0858 -1.43203 23.547 19.04 8.81464C32.3413 -0.757479 49.046 -2.13985 63.1398 3.66303C65.9485 4.81951 67.288 8.03401 66.1315 10.8428C64.9751 13.6516 61.7606 14.9911 58.9518 13.8346C48.2254 9.41816 35.5539 10.4829 25.4652 17.7431Z"
      />
    </svg>
  );
};
export default SpinnerIcon;
